export function padSoldto(soldto: string) {
	return soldto.padStart(10, '0');
}

export function unpadSoldto(soldto: string) {
	return soldto.replace(/^0+/, '');
}

export function padSupplierOrderReference(reference: string) {
	return /^\d+$/.test(reference) && reference.length < 10 ? reference.padStart(10, '0') : reference;
}
